import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage } from "react-intl";
import Select from "react-select";
import { instance } from "../../../../Actions/AxiosInstance";
import createstore from "../../../../store";
import {
  ValidateAction,
  ValidateList,
  ValidateReqField,
  ValidateReqFields,
  ValidateSearchDropdown,
} from "../../../../Utils/Validation";
import DrawerHeader from "../../../../Component/Headers/drawerHeader";
import {
  getNumberValidation,
} from "../../../../Utils/arr";

import { track } from '@amplitude/analytics-browser';

const customifsccodes = [
  {
    displayvalue:"FDRL0007777",
    displayname:"FDRL0007777"
  },
  {
    displayvalue:"FDRL0007778",
    displayname:"FDRL0007778"
  },
]

class EmpBankingForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
      isdefault: false,
      fields: {
        branchname: "",
        accountholdername: "",
        accountnumber: "",
        ifsccode: "",
        swiftcode: "",
      },
      reqFields: {
        branchname: "",
        accountholdername: "",
        accountnumber: "",
        ifsccode: "",
      },
      list: {
        banknameid: "",
        accounttype: "",
        ifsccode:"",
      },
      reqList: {
        banknameid: "",
        accounttype: "",
        ifsccode:"",
      },
      errors: {},
      helperText: {},
      banknames: [],
      accounttypes: [],
      isRequestSent: false,
      selectedIfscCode:{}
    };

    this.onCancel = this.onCancel.bind(this);
  }

  componentDidMount() {
    // CustomForm();
    if (this.firstElement) this.firstElement.focus();
  }

  componentWillMount() {
    // this.props.ChangeLanguage("");
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    const { employeeid } = SubscriptionInfo.SubscriptionData;
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
      },
      () => {
        this.GetBanknames();
        this.GetProfileBasicInfo();
      },
    );
  }


  GetProfileBasicInfo() {
    const URL = "/employee/empaboutme";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.props.colleagueid) {
        data = {
          employeeid: this.props.colleagueid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        let ProfileBasicInfo = [];
        result.data.result.length != 0
          ? (ProfileBasicInfo = result.data.result[0])
          : (ProfileBasicInfo = []);
        
        this.setState({ ProfileBasicInfo });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }


  GetPerticularBankDetails() {
    if (this.state.data) {
      const { data } = this.state;
      const { isdefault } = data;
      const { employeebankid } = data;
      const fields = {
        branchname: data.branchname,
        accountholdername: data.accountholdername,
        accountnumber: data.accountnumber,
        ifsccode: data.ifsccode,
        isdefault: data.isdefault,
        swiftcode: data.swiftcode || "",
      };
      const reqFields = {
        branchname: data.branchname,
        accountholdername: data.accountholdername,
        accountnumber: data.accountnumber,
        ifsccode: data.ifsccode,
      };
      const list = {
        banknameid: data.banknameid,
        accounttype: data.accounttype,
      };
      const reqList = {
        banknameid: data.banknameid,
        accounttype: data.accounttype,
      };
      // let selectedBankName = this.state.banknames.find(x => x.displayvalue == data.banknameid);
      // let selectedAccountType = this.state.accounttypes.find(x => x.displayvalue == data.accounttype);
      this.setState({
        fields,
        list,
        isdefault,
        employeebankid,
        reqFields,
        reqList,
      });
    }
  }

  OnFieldChange(field, type, e) {
   
    const { fields } = this.state;
    fields[field] = e.target.value ? e.target.value : "";
    if( this.props.ismandate == true && field == "branchname" && (this.state.selectedBankName.displayvalue == 16 || this.state.selectedBankName.displayvalue == 88)){
    fields.branchname =  "Jupiter"
    }
    if( this.props.ismandate == true && field == "ifsccode" && (this.state.selectedBankName.displayvalue == 16 || this.state.selectedBankName.displayvalue == 88) ){ 
    fields.ifsccode =  this.state.selectedIfscCode && this.state.selectedIfscCode.displayvalue}
    this.setState({ fields }, () => {
      ValidateAction(this.state, field, type);
    });
   
  }

  ValidateField(reqField, type, e) {
    const { reqFields } = this.state;

    if( this.props.ismandate == true && (this.state.selectedBankName.displayvalue == 16 || this.state.selectedBankName.displayvalue == 88)){
      reqFields["branchname"] =  "Jupiter";
      reqFields["ifsccode"] =  this.state.selectedIfscCode && this.state.selectedIfscCode.displayvalue;
      reqFields["accountholdername"] = this.state.ProfileBasicInfo? this.state.ProfileBasicInfo.fullname :"";

    }
    
    reqFields[reqField] = e.target.value ? e.target.value : "";
    if (!reqFields.swiftcode) {
      delete reqFields.swiftcode;
    }
    this.setState({ reqFields });
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  ValidateOnNext(reqField, type) {
    console.log('ValidateOnNext: ', "ValidateOnNext");

    const { errors } = this.state;
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
    this.setState({ errors });
    console.log('errors1: ', errors);
  }

  UpdateSelectedId(name, HtField, selectedItem) {
    const { list } = this.state;
    list[name] = selectedItem.displayvalue ? selectedItem.displayvalue : "";
    this.setState({ list });

    if ( this.props.ismandate == true && ((name == "banknameid" && selectedItem.displayvalue != 16 && selectedItem.displayvalue != 88 ) || (list.banknameid != 16 && list.banknameid != 88 ))){
      const { list } = this.state;

      list.banknameid = null;
      this.setState({ selectedBankName: "", list, 
      errors : { banknameid:true} });
      this.state.errors.banknameid
      // this.props.enqueueSnackbar("Please select mandate bank (federal or jupiter)", {
      //   variant: "error",
      // });
    }else{
      if( this.props.ismandate == false){
            if( name == "banknameid") {
              this.setState({ selectedBankName: selectedItem});
            }
            if (name == "accounttype") {
              this.setState({ selectedAccountType: selectedItem });
            }

            const { reqList } = this.state;
          delete reqList.ifsccode;
            if (reqList[name] == "" || reqList[name] || reqList[name] == null) {
              reqList[name] = selectedItem.displayvalue
                ? selectedItem.displayvalue
                : "";
              this.setState({ reqList }, () => {
                this.ValidateEachDropDown(name);
              });
            }
      }else{


            const { reqList } = this.state;
            if (reqList[name] == "" || reqList[name] || reqList[name] == null) {
              reqList[name] = selectedItem.displayvalue
                ? selectedItem.displayvalue
                : "";
              reqList["accounttype"] = 1;
             
            if( name == "banknameid") {
              this.setState({ selectedBankName: selectedItem, 
                selectedAccountType: { displayname:"Saving",displayvalue : 1},
                ifsccode:this.state.selectedIfscCode && this.state.selectedIfscCode.displayvalue,
              //  fields:{ifsccode:this.state.selectedIfscCode.displayname,branchname:"Jupiter", accountholdername: this.state.ProfileBasicInfo? this.state.ProfileBasicInfo.fullname :""},
                isdefault:true,
                list:{accounttype:1, banknameid:selectedItem.displayvalue},
               // selectedIfscCode:{ displayname:"Saving",displayvalue : 1},
                });
                
            }

            const {fields, reqFields } = this.state;

         

            if( name == "ifsccode") {
              reqFields["ifsccode"] = selectedItem && selectedItem.displayvalue;
              fields["branchname"] = "Jupiter";
              fields["ifsccode"] = selectedItem && selectedItem.displayvalue;;
             
this.setState({selectedIfscCode: selectedItem, fields, reqFields  }
 )
            }
           
              this.setState({ reqList }, () => {
                this.ValidateEachDropDown(name);
              });
            }
       }
    }
  }

  ValidateEachDropDown(name) {
    console.log('ValidateEachDropDown: ', "ValidateEachDropDown");
    ValidateSearchDropdown(this.state, name).then((result) => {
      delete result.errors.swiftcode;
      console.log('result.errors: ', result.errors);
      this.setState({
        errors: result.errors,
      });
    });
  }

  GetBanknames() {
    const data = this.state.data || {};
    const data1 = {
      countryid: null,
      subscriptionid: this.state.subscriptionid,
    };
    instance
      .post("superuser/allbankmaster", data1)
      .then((result) => {
        const banknames = [];
        banknames.push(
          { displayname: "Select Bank Name", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ banknames }, () => {
          this.setState({
            selectedBankName: banknames.find(
              (x) => x.displayvalue == data.banknameid,
            ),
            selectedIfscCode: customifsccodes.find(
              (x) => x.displayname == data.ifsccode,
            ),
          });
        });
        this.GetAccountType();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetAccountType() {
    const data = this.state.data || {};
    instance
      .get("superuser/getmastercode/AccountType")
      .then((result) => {
        let accounttypes = [];
        accounttypes = result.data.result;
        this.setState({ accounttypes }, () => {
          this.setState({
            selectedAccountType: accounttypes.find(
              (x) => x.displayvalue == data.accounttype,
            ),
          });
        });
        this.GetPerticularBankDetails();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  Validate() {
    let formIsValid = true;
    const allstate = { ...this.state };
    delete allstate.fields.swiftcode;
    if (!ValidateReqFields(allstate)) {
      formIsValid = false;
    }
    if (!ValidateList(this.state)) {
      formIsValid = false;
    }
    return formIsValid;
  }

  AddBankDetails() {
    if (!this.Validate()) {
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });
    } else if( getNumberValidation(this.state.fields.accountnumber) == false ){
      this.props.enqueueSnackbar("Invalid bank account", {
        variant: "error",
      });
    } else {
      let flag;
      // this.state.employeebankid ? flag = 3 : flag = 2
      if (
        !createstore.getState().AuthenticationAction.IsFulfilled ||
        this.state.employeebankid
      ) {
        flag = 3;
      } else {
        flag = 2;
      }
      const data = {
        employeebankid: this.state.employeebankid,
        banknameid: this.state.list.banknameid,
        branchname: this.state.fields.branchname,
        accountholdername: this.state.fields.accountholdername,
        accountnumber: this.state.fields.accountnumber,
        accounttype: this.state.list.accounttype,
        ifsccode: this.props.ismandate ? this.state.selectedIfscCode && this.state.selectedIfscCode.displayvalue : this.state.fields.ifsccode,
        swiftcode: this.state.fields.swiftcode,
        isdefault: this.state.isdefault,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
      if (!createstore.getState().AuthenticationAction.IsFulfilled) {
        Object.assign(data, {
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
          employeeid: this.props.colleagueid || this.state.employeeid,
        });
      }
      instance
        .post("employee/insertupdateempbankdetail", data)
        .then(() => {
          if (this.state.isRequestSent == true) {
            this.props.enqueueSnackbar(
              " Request has been sent for default setting changes",
              { variant: "success" },
            );
          }
          if(this.state.data) {
          this.props.enqueueSnackbar("Request for updating bank details sent successfully", {
            variant: "success",
          });
        } else{
          this.props.enqueueSnackbar("Bank Details Saved successfully", {
            variant: "success",
          });
        }
          this.setState({
            employeebankid: "",
            banknameid: "",
            branchname: "",
            accountnumber: "",
            accounttype: "",
            ifsccode: "",
            swiftcode: "",
            isdefault: "",
            selectedBankName: "",
            selectedAccountType: "",
            isRequestSent: false,
            flag:3,
            openDrawer:false
          });
          this.props.SetFlag(3, true);
          this.props.toggleDrawer(false);
          track("saved-jupiter-bank");
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  onCancel() {
    this.props.SetFlag(3, true);
    this.props.toggleDrawer(false);
    track("cancelled-saving-jupiter-bank");
  }

  ChangeIsDefaultState(name, event) {
    let isRequestSent = false;
    if (this.state.employeebankid && this.state.isdefault == false) {
      event.target.checked == true
        ? (isRequestSent = true)
        : (isRequestSent = false);
    }
    this.setState({ [name]: event.target.checked, isRequestSent });
  }

  render() {
    return (
      // <div className="emp-from-wrapper imp-dates">
        // <div className="form-height">
        
          <div className="padding20">
            <DrawerHeader
            header="Add Banking details"
            isbackarrow={false}
            closeDrawer={() => this.props.toggleDrawer(false)}
          />
            <div className="custom-form-box profile-banking" autoComplete="off">
              <div className="inner-wrapper opaque" tabIndex="0" style={{position:"relative", zIndex:6}}>
                <div className="form-group">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbBankName"
                      defaultMessage="Bank Name"
                    />{" "}
                  </p>
                  <Select
                    className="selectsearch BankName"
                    onChange={this.UpdateSelectedId.bind(
                      this,
                      "banknameid",
                      "HtBankName",
                    )}
                    options={this.state.banknames}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    value={this.state.selectedBankName}
                    placeholder="Select Bank Name"
                    ref={(r) => {
                      this.firstElement = r;
                    }}
                  // selected={(option)=>option.displayvalue == props.Selected}
                  />
                  <div>
                    {this.state.errors.banknameid ? (
                       track("non-jupiter-bank-selected"),
                      <span className="caption-error">
                       
                        <FormattedMessage
                          id="Erbankname"
                          defaultMessage= {this.props.ismandate == true ? "For adding other banks please reach out to your HR." : " Please select bank"}
                        />
                      </span>
                    ) : (
                        ""
                      )}
                  </div>
                </div>
              </div>
              {this.props.ismandate ==false ? (
              <div className="inner-wrapper opaque" tabIndex="1" style={{position:"relative", zIndex:5}}>
                <div className="form-group">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbBranchName"
                      defaultMessage="Branch Name"
                    />
                  </p>
                  <div>
                    <TextField
                      className="branchname"
                      id="outlined-dense"
                      margin="dense"
                      variant="outlined"
                      placeholder="Branch Name"
                      onChange={this.OnFieldChange.bind(
                        this,
                        "branchname",
                        "name",
                      )}
                      onBlur={this.ValidateField.bind(
                        this,
                        "branchname",
                        "name",
                      )}
                      value={this.state.fields.branchname}
                      maxLength="90"
                    />
                  </div>
                  <div>
                    {this.state.errors.branchname ? (
                      <span className="caption-error">
                        {" "}
                        <FormattedMessage
                          id="Erbranchname"
                          defaultMessage="can not be empty"
                        />
                      </span>
                    ) : (
                        ""
                      )}
                  </div>
                </div>
              </div>
              ):("")}
              <div className="inner-wrapper opaque" tabIndex="2" style={{position:"relative", zIndex:4}}>
                <div className="form-group">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbAccountHolderName"
                      defaultMessage="Account Holder Name"
                    />
                  </p>
                  <div>
                    <TextField
                      className="accountholdername"
                      id="outlined-dense"
                      margin="dense"
                      variant="outlined"
                      placeholder="Account Holder Name"
                      onChange={this.OnFieldChange.bind(
                        this,
                        "accountholdername",
                        "text",
                      )}
                      onBlur={this.ValidateField.bind(
                        this,
                        "accountholdername",
                        "name",
                      )}
                      value={this.state.fields.accountholdername}
                      maxLength="90"
                    />
                  </div>
                  <div>
                    {this.state.errors.accountholdername ? (
                      <span className="caption-error">
                        {" "}
                        <FormattedMessage
                          id="Eraccountholdername"
                          defaultMessage="can not be empty"
                        />
                      </span>
                    ) : (
                        ""
                      )}
                  </div>
                </div>
              </div>
              <div className="inner-wrapper opaque" tabIndex="3" style={{position:"relative", zIndex:3}}>
                <div className="form-group">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbAccountNumber"
                      defaultMessage="Account Number"
                    />
                  </p>
                  <div>
                    <TextField
                      className="accountnumber"
                      id="outlined-dense"
                      margin="dense"
                      variant="outlined"
                      placeholder="Account Number"
                      onChange={this.OnFieldChange.bind(
                        this,
                        "accountnumber",
                        "text",
                      )}
                      onBlur={this.ValidateField.bind(
                        this,
                        "accountnumber",
                        "text",
                      )}
                      value={this.state.fields.accountnumber}
                      maxLength="40"
                    />
                  </div>
                  <div>
                    {this.state.errors.accountnumber ? (
                      <span className="caption-error">
                        {" "}
                        <FormattedMessage
                          id="Eraccountnumber"
                          defaultMessage="can not be empty"
                        />
                      </span>
                    ) : (
                        ""
                      )}
                  </div>
                </div>
              </div>
              {this.props.ismandate == false ? (
              <div className="inner-wrapper opaque" tabIndex="4" style={{position:"relative", zIndex:2}}>
                <div className="form-group">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbAccountType"
                      defaultMessage="Account Type"
                    />{" "}
                  </p>
                  <Select
                    className="selectsearch AccountType"
                    onChange={this.UpdateSelectedId.bind(
                      this,
                      "accounttype",
                      "HtAccountType",
                    )}
                    options={this.state.accounttypes}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    value={this.state.selectedAccountType}
                    placeholder="Select Account Type"
                  // selected={(option)=>option.displayvalue == props.Selected}
                  />
                  <div>
                    {this.state.errors.accounttype ? (
                      <span className="caption-error">
                        <FormattedMessage
                          id="ErAccountType"
                          defaultMessage="please select Account Type"
                        />
                      </span>
                    ) : (
                        ""
                      )}
                  </div>
                </div>
              </div>
               ) : (
                ""
              )}

{this.state.selectedBankName && (this.state.selectedBankName.displayvalue == 16 || this.state.selectedBankName.displayvalue == 88) && this.props.ismandate ?
 <div className="inner-wrapper opaque" tabIndex="5" style={{position:"relative", zIndex:1}}>
<div className="form-group">
   <p className="input-form-label">
                    <FormattedMessage
                      id="LbIFSCcode"
                      defaultMessage="IFSC code"
                    />
                  </p>
  <Select
                    className="selectsearch AccountType"
                    onChange={this.UpdateSelectedId.bind(
                      this,
                      "ifsccode",
                      "HtAccountType",
                    )}
                    options={customifsccodes}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    value={this.state.selectedIfscCode}
                    placeholder="Select IFSC code"
                  // selected={(option)=>option.displayvalue == props.Selected}
                  />
                  </div>
                  </div>

             : <div className="inner-wrapper opaque" tabIndex="5" style={{position:"relative", zIndex:1}}>
                <div className="form-group">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbIFSCcode"
                      defaultMessage="IFSC code"
                    />
                  </p>
                  <div>
                    <TextField
                      className="ifsccode"
                      id="outlined-dense"
                      margin="dense"
                      variant="outlined"
                      placeholder="IFSC code"
                      onChange={this.OnFieldChange.bind(
                        this,
                        "ifsccode",
                        "text",
                      )}
                      onBlur={this.ValidateField.bind(this, "ifsccode", "text")}
                      value={this.state.fields.ifsccode}
                      maxLength="40"
                    />
                  </div>
                  <div>
                    {this.state.errors.ifsccode ? (
                      <span className="caption-error">
                        {" "}
                        <FormattedMessage
                          id="Erifsccode"
                          defaultMessage="can not be empty"
                        />
                      </span>
                    ) : (
                        ""
                      )}
                  </div>
                </div>
              </div>
}
              {/* <div className="inner-wrapper opaque" tabIndex="5">
                <div className="form-group">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="__LbSwiftCode"
                      defaultMessage="Swift code (Optional)"
                    />
                  </p>
                  <div>
                    <TextField
                      className="swiftcode"
                      id="outlined-dense"
                      margin="dense"
                      variant="outlined"
                      placeholder="Swift code"
                      onChange={this.OnFieldChange.bind(
                        this,
                        "swiftcode",
                        "text",
                      )}
                      onBlur={this.ValidateField.bind(
                        this,
                        "swiftcode",
                        "text",
                      )}
                      value={this.state.fields.swiftcode}
                      maxLength="40"
                    />
                  </div>
                  <div>
                    {this.state.errors.swiftcode ? (
                      <span className="caption-error">
                        {" "}
                        <FormattedMessage
                          id="Erswiftcode"
                          defaultMessage="can not be empty"
                        />
                      </span>
                    ) : (
                        ""
                      )}
                  </div>
                </div>
              </div> */}
              <div className="inner-wrapper opaque" tabIndex="6" style={{position:"relative", zIndex:0}}>
                <div className="form-group">
                  <Checkbox
                    color="primary"
                    classname="inlineClass banking-chkbox"
                    checked={this.state.isdefault}
                    onChange={this.ChangeIsDefaultState.bind(this, "isdefault")}
                    value={this.state.isdefault}
                  // style={{width: 50 !important }}
                  />
                  <p className="input-form-label inlineClass">
                    Would you like to keep this as your default bank account?
                  </p>

                  {/* <div>
                                        {!!this.state.errors["isdefault"] ? <span className="caption-error"> <FormattedMessage
                                            id="Erisdefault"
                                            defaultMessage="can not be empty"
                                        /></span> : ''}
                                    </div> */}
                </div>
              </div>
              <div className="upform-footer">
                {/* <Button type="Button" class="form-btn form-control" onClick={this.AddBankDetails.bind(this)}>SAVE</Button> */}

                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={this.state.errors.banknameid ? "form-btn save btn btn-primary-md-grey" : "form-btn save"}
                  onClick={this.AddBankDetails.bind(this)}
                  disabled={this.state.errors.banknameid}
                  
                >
                  <FormattedMessage id="BtSave" defaultMessage="Save" />
                </Button>
                <span className="margin-left-16"></span>
                <Button size="large" onClick={this.onCancel} className="Cancel">
                  <FormattedMessage id="BtCancel" defaultMessage="Cancel" />
                </Button>
              </div>
            </div>
          </div>
      //   {/* </div> */}
      // {/* // </div> */}
    );
  }
}

export default withSnackbar(EmpBankingForm);
